import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CheckOutDetails } from '../CheckOut.models';
import { CheckOutService } from '../CheckOut.service';
import { CheckOutActions } from '../CheckOutActions';

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html'
})
export class PaymentDetailsComponent extends CheckOutActions implements OnInit {

  @Input() override currentOrderId!: number;
  @Input() restaurantId!: any;
  @Output() close = new EventEmitter<boolean>();

  dataLoading = false;
  details!: CheckOutDetails;

  private unsubscribe$: Subject<any> = new Subject<any>();

  constructor(
    checkoutService: CheckOutService,
    translate: TranslateService
  ) {
    super(checkoutService, translate)
  }

  ngOnInit(): void {
    this.checkoutService.refreshView.pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.getCheckoutDetails()
      });
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  getCheckoutDetails() {
    this.dataLoading = true;
    this.checkoutService.ResGetOrderPaymentById(this.currentOrderId)
      .subscribe( data => {
        this.dataLoading = false;
        this.details = data;
      }, err => {
        console.error(err);
      });
  }

}
